import { Icon } from '@/components/ui/Icon';
import { useUiStore } from '@/store/ui.store';
import { BrandMark } from './BrandMark';

const DATE_RANGES = ['Today', 'Last 7 days', 'Last 30 days', 'This month'];

export function Topbar() {
  const toggleMobileNav = useUiStore((s) => s.toggleMobileNav);

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-brand/10 bg-base/70 px-4 backdrop-blur-xl lg:px-8">
      <button
        onClick={toggleMobileNav}
        aria-label="Open menu"
        className="focus-ring rounded-lg p-2 text-muted hover:text-content lg:hidden"
      >
        <Icon name="list" size={22} />
      </button>

      <div className="lg:hidden">
        <BrandMark size="sm" />
      </div>

      <div className="ml-auto flex items-center gap-2">
        <button
          aria-label="Search"
          className="focus-ring rounded-full border border-brand/15 bg-surface/60 p-2.5 text-muted hover:text-content"
        >
          <Icon name="search" size={18} />
        </button>

        <button
          aria-label="Notifications"
          className="focus-ring relative rounded-full border border-brand/15 bg-surface/60 p-2.5 text-muted hover:text-content"
        >
          <Icon name="bell" size={18} />
          <span className="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-danger text-[0.6rem] font-bold text-white">
            1
          </span>
        </button>

        <div className="relative hidden md:block">
          <select
            defaultValue="Last 30 days"
            aria-label="Date range"
            className="focus-ring h-10 appearance-none rounded-lg border border-brand/15 bg-surface/60 pl-9 pr-8 text-sm font-medium text-content"
          >
            {DATE_RANGES.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
          <Icon
            name="calendar"
            size={16}
            className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-muted"
          />
          <Icon
            name="chevronDown"
            size={16}
            className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-muted"
          />
        </div>
      </div>
    </header>
  );
}
